var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg3Quat1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 125.7 315.3",
    enableBackground: "new 0 0 125.7 315.3",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 9.1,
    y: 78.7,
    fill: "#FFFFFF",
    width: 107.4,
    height: 61.4
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B4B3B2",
    d: "M117.1,140.6H8.6V78.2h108.4V140.6z M9.6,139.6h106.4V79.2H9.6V139.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 9.1,
    y: 143.6,
    fill: "#FFFFFF",
    width: 107.4,
    height: 61.9
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B4B3B2",
    d: "M117.1,206H8.6v-62.9h108.4V206z M9.6,205h106.4v-60.9H9.6V205z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 9.1,
    y: 209.6,
    fill: "#FFFFFF",
    width: 107.4,
    height: 61.9
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B4B3B2",
    d: "M117.1,272H8.6v-62.9h108.4V272z M9.6,271h106.4v-60.9H9.6V271z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 9.1,
    y: 0,
    fill: "#E3E3E3",
    width: 107.4,
    height: 76
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B4B3B2",
    d: "M117.1,76.5H8.6v-77h108.4V76.5z M9.6,75.5h106.4v-75H9.6V75.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 13.7,
    y: 202.2,
    fill: "#B4B3B2",
    width: 1,
    height: 9.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 202.2,
    fill: "#B4B3B2",
    width: 1,
    height: 9.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22.2,
    y: 202.2,
    fill: "#B4B3B2",
    width: 1,
    height: 9.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.5,
    y: 202.2,
    fill: "#B4B3B2",
    width: 1,
    height: 9.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.7,
    y: 202.2,
    fill: "#B4B3B2",
    width: 1,
    height: 9.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 202.2,
    fill: "#B4B3B2",
    width: 1,
    height: 9.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39.2,
    y: 202.2,
    fill: "#B4B3B2",
    width: 1,
    height: 9.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 43.5,
    y: 202.2,
    fill: "#B4B3B2",
    width: 1,
    height: 9.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 47.7,
    y: 202.2,
    fill: "#B4B3B2",
    width: 1,
    height: 9.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 202.2,
    fill: "#B4B3B2",
    width: 1,
    height: 9.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.2,
    y: 202.2,
    fill: "#B4B3B2",
    width: 1,
    height: 9.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60.5,
    y: 202.2,
    fill: "#B4B3B2",
    width: 1,
    height: 9.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64.7,
    y: 202.2,
    fill: "#B4B3B2",
    width: 1,
    height: 9.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69,
    y: 202.2,
    fill: "#B4B3B2",
    width: 1,
    height: 9.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 73.2,
    y: 202.2,
    fill: "#B4B3B2",
    width: 1,
    height: 9.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 77.5,
    y: 202.2,
    fill: "#B4B3B2",
    width: 1,
    height: 9.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 81.7,
    y: 202.2,
    fill: "#B4B3B2",
    width: 1,
    height: 9.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86,
    y: 202.2,
    fill: "#B4B3B2",
    width: 1,
    height: 9.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 90.2,
    y: 202.2,
    fill: "#B4B3B2",
    width: 1,
    height: 9.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 94.5,
    y: 202.2,
    fill: "#B4B3B2",
    width: 1,
    height: 9.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98.7,
    y: 202.2,
    fill: "#B4B3B2",
    width: 1,
    height: 9.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103,
    y: 202.2,
    fill: "#B4B3B2",
    width: 1,
    height: 9.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.2,
    y: 202.2,
    fill: "#B4B3B2",
    width: 1,
    height: 9.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 111.5,
    y: 202.2,
    fill: "#B4B3B2",
    width: 1,
    height: 9.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 13.7,
    y: 136.9,
    fill: "#B4B3B2",
    width: 1,
    height: 9.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 136.9,
    fill: "#B4B3B2",
    width: 1,
    height: 9.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22.2,
    y: 136.9,
    fill: "#B4B3B2",
    width: 1,
    height: 9.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.5,
    y: 136.9,
    fill: "#B4B3B2",
    width: 1,
    height: 9.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.7,
    y: 136.9,
    fill: "#B4B3B2",
    width: 1,
    height: 9.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 136.9,
    fill: "#B4B3B2",
    width: 1,
    height: 9.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39.2,
    y: 136.9,
    fill: "#B4B3B2",
    width: 1,
    height: 9.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 43.5,
    y: 136.9,
    fill: "#B4B3B2",
    width: 1,
    height: 9.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 47.7,
    y: 136.9,
    fill: "#B4B3B2",
    width: 1,
    height: 9.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 136.9,
    fill: "#B4B3B2",
    width: 1,
    height: 9.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.2,
    y: 136.9,
    fill: "#B4B3B2",
    width: 1,
    height: 9.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60.5,
    y: 136.9,
    fill: "#B4B3B2",
    width: 1,
    height: 9.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64.7,
    y: 136.9,
    fill: "#B4B3B2",
    width: 1,
    height: 9.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69,
    y: 136.9,
    fill: "#B4B3B2",
    width: 1,
    height: 9.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 73.2,
    y: 136.9,
    fill: "#B4B3B2",
    width: 1,
    height: 9.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 77.5,
    y: 136.9,
    fill: "#B4B3B2",
    width: 1,
    height: 9.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 81.7,
    y: 136.9,
    fill: "#B4B3B2",
    width: 1,
    height: 9.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86,
    y: 136.9,
    fill: "#B4B3B2",
    width: 1,
    height: 9.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 90.2,
    y: 136.9,
    fill: "#B4B3B2",
    width: 1,
    height: 9.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 94.5,
    y: 136.9,
    fill: "#B4B3B2",
    width: 1,
    height: 9.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98.7,
    y: 136.9,
    fill: "#B4B3B2",
    width: 1,
    height: 9.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103,
    y: 136.9,
    fill: "#B4B3B2",
    width: 1,
    height: 9.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.2,
    y: 136.9,
    fill: "#B4B3B2",
    width: 1,
    height: 9.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 111.5,
    y: 136.9,
    fill: "#B4B3B2",
    width: 1,
    height: 9.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 13.7,
    y: 72.4,
    fill: "#B4B3B2",
    width: 1,
    height: 9.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 72.4,
    fill: "#B4B3B2",
    width: 1,
    height: 9.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22.2,
    y: 72.4,
    fill: "#B4B3B2",
    width: 1,
    height: 9.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.5,
    y: 72.4,
    fill: "#B4B3B2",
    width: 1,
    height: 9.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.7,
    y: 72.4,
    fill: "#B4B3B2",
    width: 1,
    height: 9.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 72.4,
    fill: "#B4B3B2",
    width: 1,
    height: 9.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39.2,
    y: 72.4,
    fill: "#B4B3B2",
    width: 1,
    height: 9.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 43.5,
    y: 72.4,
    fill: "#B4B3B2",
    width: 1,
    height: 9.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 47.7,
    y: 72.4,
    fill: "#B4B3B2",
    width: 1,
    height: 9.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 72.4,
    fill: "#B4B3B2",
    width: 1,
    height: 9.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56.2,
    y: 72.4,
    fill: "#B4B3B2",
    width: 1,
    height: 9.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60.5,
    y: 72.4,
    fill: "#B4B3B2",
    width: 1,
    height: 9.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64.7,
    y: 72.4,
    fill: "#B4B3B2",
    width: 1,
    height: 9.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69,
    y: 72.4,
    fill: "#B4B3B2",
    width: 1,
    height: 9.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 73.2,
    y: 72.4,
    fill: "#B4B3B2",
    width: 1,
    height: 9.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 77.5,
    y: 72.4,
    fill: "#B4B3B2",
    width: 1,
    height: 9.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 81.7,
    y: 72.4,
    fill: "#B4B3B2",
    width: 1,
    height: 9.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86,
    y: 72.4,
    fill: "#B4B3B2",
    width: 1,
    height: 9.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 90.2,
    y: 72.4,
    fill: "#B4B3B2",
    width: 1,
    height: 9.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 94.5,
    y: 72.4,
    fill: "#B4B3B2",
    width: 1,
    height: 9.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98.7,
    y: 72.4,
    fill: "#B4B3B2",
    width: 1,
    height: 9.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 103,
    y: 72.4,
    fill: "#B4B3B2",
    width: 1,
    height: 9.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.2,
    y: 72.4,
    fill: "#B4B3B2",
    width: 1,
    height: 9.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 111.5,
    y: 72.4,
    fill: "#B4B3B2",
    width: 1,
    height: 9.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    fill: "#FFFFFF",
    cx: 62.9,
    cy: 8.4,
    r: 2.1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B4B3B2",
    d: "M62.9,11c-1.4,0-2.6-1.2-2.6-2.6s1.2-2.6,2.6-2.6s2.6,1.2,2.6,2.6S64.3,11,62.9,11z M62.9,6.7 c-0.9,0-1.6,0.7-1.6,1.6S62,10,62.9,10s1.6-0.7,1.6-1.6S63.8,6.7,62.9,6.7z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg3Quat1);
export default __webpack_public_path__ + "static/media/3quat_1.ed59aa6095fc59291f9d57200b2d991f.svg";
export { ForwardRef as ReactComponent };